import UsuariosService from "@/services/accounts/UsuariosService";



const users = (context, params) => {
  return UsuariosService.fetch(params)
    .then(res => {
      context.commit('USERS', res.data);
    });
};





export default {
  users,
};